import {StrictMode} from "react"
import {AppStoreProvider} from "@/providers/AppStoreProvider"
import {createRoot} from "react-dom/client"
import {AppRouterProvider} from "@/providers/AppRouterProvider"
import {AppI18nProvider} from "@/providers/AppI18nProvider"
import "@/assets/drop.scss"
import "@reown/appkit-wallet-button/react"
import {QueryClient, QueryClientProvider} from "@tanstack/react-query"

import {ToastProvider} from "@/components/ui/Toast/Toast"

import {BalanceProvider} from "@/context/BalanceContext.tsx"
import {ProgramProvider} from "@/context/ProgramContext.tsx"
import {UserPoolsProvider} from "@/context/UserPoolsContext.tsx"
import {createTheme, ThemeProvider} from '@mui/material/styles'
import * as Sentry from "@sentry/react";
import "@/appkit.ts";
import {ReownProvider} from "@/context/AuthContext.tsx";
import {SolanaBalanceProvider} from "@/context/SolanaBalanceContext.tsx"; //dont remove

// Sentry.init({
//   dsn: "https://c794dbae0c75805f8cf4f48ea7d0368c@o4509764407066624.ingest.de.sentry.io/4509764408705104",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   debug: false,
//   integrations: [
//     Sentry.replayIntegration()
//   ],
//   // Session Replay
//   replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 0.1 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   ,environment: import.meta.env.MODE,
// });

//console.log("import.meta.env.MODE", import.meta.env, process.env)

const root =
  document.getElementById("root") ??
  (() => {
    const r = document.createElement("div")
    document.appendChild(r)
    return r
  })()



const queryClient = new QueryClient()

// console.log(appkit.subscribeAccount(ac=>{
//   // console.log(appkit.getAddress("solana"))
// }))

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, Urbanist, sans-serif',
  },
}) /*mui components global font*/

createRoot(root).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <AppI18nProvider>
        <AppStoreProvider>
          {/*<WagmiProvider config={wagmiAdapter.wagmiConfig}>*/}
          <QueryClientProvider client={queryClient}>
            <ToastProvider>
              <ReownProvider>
                <ProgramProvider>
                  <SolanaBalanceProvider>
                  {/*<BalanceProvider>*/}
                    <UserPoolsProvider>

                      <AppRouterProvider/>
                    </UserPoolsProvider>
                  {/*</BalanceProvider>*/}
                </SolanaBalanceProvider>
                </ProgramProvider>
              </ReownProvider>
            </ToastProvider>
          </QueryClientProvider>
          {/*</WagmiProvider>*/}
        </AppStoreProvider>
      </AppI18nProvider>
    </ThemeProvider>
  </StrictMode>,
)
